//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import  IngresoCobranzaManager from '../../../Common/Managers/IngresoCobranzaManager';

export const GET_DATA_INGRESO_COBRANZAS = 'GET_DATA_INGRESO_COBRANZAS';
export const RECEIVE_DATA_INGRESO_COBRANZAS = 'RECEIVE_DATA_INGRESO_COBRANZAS';
export const INITIAL_STATE_INGRESO_COBRANZAS = 'INITIAL_STATE_INGRESO_COBRANZAS';
export const RESET_STATE_INGRESO_COBRANZAS = 'RESET_STATE_INGRESO_COBRANZAS';
export const LIMPIAR_INGRESO_COBRANZAS = 'LIMPIAR_INGRESO_COBRANZAS';
export const ACEPTAR_INGRESO_COBRANZAS = 'ACEPTAR_INGRESO_COBRANZAS';
export const ACTUALIZAR_INGRESO_COBRANZAS = 'ACTUALIZAR_INGRESO_COBRANZAS';
export const EDITAR_INGRESO_COBRANZAS = 'EDITAR_INGRESO_COBRANZAS';
export const CONFIRMAR_INGRESO_COBRANZAS = 'CONFIRMAR_INGRESO_COBRANZAS';
export const DENEGAR_INGRESO_COBRANZAS = 'DENEGAR_INGRESO_COBRANZAS';
export const ELIMINAR_INGRESO_COBRANZAS = 'ELIMINAR_INGRESO_COBRANZAS';
export const SUCCESS_INGRESO_COBRANZAS = 'SUCCESS_INGRESO_COBRANZAS';
export const LOADING_INGRESO_COBRANZAS = 'LOADING_INGRESO_COBRANZAS';
export const SELECCIONAR_MONEDA_INGRESO_COBRANZAS = 'SELECCIONAR_MONEDA_INGRESO_COBRANZAS';
export const EXPANDIR_ROW_INGRESO_COBRANZAS = 'EXPANDIR_ROW_INGRESO_COBRANZAS';
export const CHANGE_IMPORTE_INGRESO_COBRANZAS = 'CHANGE_IMPORTE_INGRESO_COBRANZAS';
export const CHANGE_REFERENCIA_INGRESO_COBRANZAS = 'CHANGE_REFERENCIA_INGRESO_COBRANZAS';
export const CHANGE_DATE_INGRESO_COBRANZAS = 'CHANGE_DATE_INGRESO_COBRANZAS';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _vistaCliente, _currentAccount = null;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 * @param {any} currentAccount
 */
export function getScreenData(currentScope, currentAccount) {
    LogHelper.In(getScreenData.name, currentScope, currentAccount);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));

        _dispatch = dispatch;
        _currentAccount = currentAccount;

        dispatch({ type: GET_DATA_INGRESO_COBRANZAS });

        IngresoCobranzas();
    }
}

export function aceptar(cobranza, accion, resetFields) {
    LogHelper.In(aceptar.name, cobranza, accion, resetFields);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: LOADING_INGRESO_COBRANZAS });
        if (accion == "guardar") {
            IngresoCobranzaManager.GuardarCobranza(cobranza, () => viewCallback(resetFields, dispatch));
        }
        else {
            IngresoCobranzaManager.ActualizarCobranza(cobranza, () => viewCallback(resetFields, dispatch));
        }
    }
}

export function actualizar() {
    LogHelper.In(actualizar.name, cobranza, accion, resetFields);

    return () => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: ACTUALIZAR_INGRESO_COBRANZAS });
        IngresoCobranzaManager.ActualizarCobranza(cobranza, () => IngresoCobranzas());
        
    }
}

export function eliminar(cobranza, estado) {
    LogHelper.In(eliminar.name, cobranza, estado);

    return (dispatch, getState) => {
        let state = getState();
        cobranza.CobranzaEstadoId = estado;
        cobranza.FechaCambioEstado = new Date();
        cobranza.UsuarioUltModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: ELIMINAR_INGRESO_COBRANZAS });
        IngresoCobranzaManager.EliminarCobranza(cobranza, () => IngresoCobranzas());
        
    }
}

export function editar(cobranza) {
    LogHelper.In(editar.name, cobranza);

    return (dispatch, getState) => {
        dispatch({ type: EDITAR_INGRESO_COBRANZAS, cobranza: cobranza });
    }
}

export function confirmar(cobranza, estado) {
    LogHelper.In(confirmar.name, cobranza, estado);

    return (dispatch, getState) => {
        let state = getState();
        cobranza.CobranzaEstadoId = estado;
        cobranza.FechaCambioEstado = new Date();
        cobranza.UsuarioUltModif = state.sesion.executionContext.login;
        dispatch({ type: CONFIRMAR_INGRESO_COBRANZAS });
        IngresoCobranzaManager.ActualizarCobranza(cobranza, () => IngresoCobranzas());
    }
}

export function denegar(cobranza, estado) {
    LogHelper.In(denegar.name, cobranza, estado);

    return (dispatch, getState) => {
        let state = getState();
        cobranza.CobranzaEstadoId = estado;
        cobranza.FechaCambioEstado = new Date();
        cobranza.UsuarioUltModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: DENEGAR_INGRESO_COBRANZAS });
        IngresoCobranzaManager.ActualizarCobranza(cobranza, () => IngresoCobranzas());
        
    }
}

export function seleccionarMoneda(monedaId) {
    LogHelper.In(seleccionarMoneda.name);

    return (dispatch) => {
        dispatch({ type: SELECCIONAR_MONEDA_INGRESO_COBRANZAS, monedaId: monedaId });
    }
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: RESET_STATE_INGRESO_COBRANZAS });
    }
}

export function limpiar() {
    LogHelper.In(limpiar.name);

    return (dispatch) => {
        dispatch({ type: LIMPIAR_INGRESO_COBRANZAS });
    }
}

export function expandirRow(id) {
    LogHelper.In(expandirRow.name, id);

    return (dispatch) => {
        dispatch({ type: EXPANDIR_ROW_INGRESO_COBRANZAS, id: id });
    }
}

export function changeImporte(importe) {
    LogHelper.In(changeImporte.name, importe);

    return (dispatch) => {
        dispatch({ type: CHANGE_IMPORTE_INGRESO_COBRANZAS, importe: importe });
    }
}

export function changeReferencia(referencia) {
    LogHelper.In(changeReferencia.name, referencia);

    return (dispatch) => {
        dispatch({ type: CHANGE_REFERENCIA_INGRESO_COBRANZAS, referencia: referencia });
    }
}

export function changeDate(date) {
    LogHelper.In(changeDate.name, date);

    return (dispatch) => {
        dispatch({ type: CHANGE_DATE_INGRESO_COBRANZAS, fechaValor: date });
    }
}
/*-------------------FUNCIONES AUXILIARES-------------------------*/

function getIngresoCobranzasData(data, dispatch) {
    let GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE = JSON.parse(data.GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE);

    const GET_COBRANZAS_DATOS_EXTRAS = JSON.parse(data.GET_COBRANZAS_DATOS_EXTRAS);

    let result = {
        cobranzas: GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE.Recordset0.Rows,
        tipoMoneda: GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE.Recordset1.Rows,
        fechaCobranza: GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE.Recordset2.Rows[0].FechaCobranza,
        sucursalId: GET_COBRANZAS_DATOS_EXTRAS.Recordset0.Rows[0] ? GET_COBRANZAS_DATOS_EXTRAS.Recordset0.Rows[0].SucursalId : undefined,
        cobranzaEstadoId: GET_COBRANZAS_DATOS_EXTRAS.Recordset1.Rows[0] ? GET_COBRANZAS_DATOS_EXTRAS.Recordset1.Rows[0].Id : undefined,
        cobranzaOrigenId: GET_COBRANZAS_DATOS_EXTRAS.Recordset2.Rows[0] ? GET_COBRANZAS_DATOS_EXTRAS.Recordset2.Rows[0].Id : undefined,
        formaPagoId: GET_COBRANZAS_DATOS_EXTRAS.Recordset3.Rows[0] ? GET_COBRANZAS_DATOS_EXTRAS.Recordset3.Rows[0].Id : undefined,
        tarjetaCreditoId: GET_COBRANZAS_DATOS_EXTRAS.Recordset4.Rows[0] ? GET_COBRANZAS_DATOS_EXTRAS.Recordset4.Rows[0].Id : undefined,
        cuentaTarjetaId: _currentAccount
    }

    dispatch({ type: RECEIVE_DATA_INGRESO_COBRANZAS, data: result });
}

function viewCallback(resetFields, dispatch) {
    resetFields();
    dispatch({ type: LIMPIAR_INGRESO_COBRANZAS });
    dispatch({ type: SUCCESS_INGRESO_COBRANZAS });
    IngresoCobranzas();
}

function IngresoCobranzas() {
    let params = {
        'CUENTA_TARJETA_ID': _currentAccount
    };
    
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_COBRANZAS_REGISTRADAS_DESDE_ULTIMO_CIERRE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_COBRANZAS_DATOS_EXTRAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => getIngresoCobranzasData(data, _dispatch), null, null, "CONSULTASOCIOS");
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/IngresoCobranzas/actions/IngresoCobranzasActions.js